<div
  class="block"
  class:from-self={fromSelf(note)}
  class:from-other={!fromSelf(note)}>
  <div class="is-size-7 metadata mb-1">
    {fromSelf(note) ? '' : note.data.userId}
    <span class="has-text-grey-light">{dayjs().to(note.data.timestamp)}</span>
  </div>
  <div
    class="message"
    class:is-info={fromSelf(note)}
    class:is-dark={!fromSelf(note)}
    on:mouseenter={() => {
      showMessageActions = true;
    }}
    on:mouseleave={() => {
      showMessageActions = false;
    }}>
    <div class="message-body" style="position:relative;">
      {#if showMessageEditing}
        <div class="block">
          <textarea
            class="textarea"
            bind:value={noteTextEditable}
            rows={noteLineCount} />
        </div>
        <button
          class="button is-primary"
          on:click={() => {
            dispatch('noteUpdated', { noteId: note.id, text: noteTextEditable });
            showMessageEditing = false;
          }}>Save</button>
        <button
          class="button"
          on:click={() => {
            showMessageEditing = false;
          }}>Cancel</button>
      {:else}
        <span style="white-space:pre-wrap">{note.data.text}</span>
        {#if showMessageActions}
          <div style="position:absolute; right:20px; top: 20px;">
            <!-- svelte-ignore a11y-missing-attribute -->
            <a
              on:click={() => {
                showMessageEditing = true;
                noteTextEditable = note.data.text;
              }}>
              <span class="icon">
                <i class="mdi mdi-pencil" />
              </span>
            </a>
            <!-- svelte-ignore a11y-missing-attribute -->
            <a
              on:click={() => {
                dispatch('noteDeleted', { noteId: note.id });
              }}>
              <span class="icon">
                <i class="mdi mdi-delete" />
              </span>
            </a>
          </div>
        {/if}
      {/if}
    </div>
  </div>
</div>

<script lang="ts">
  export let note: Note_v1_Doc;

  import { appState } from '../../../lib/appState';
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  dayjs.extend(relativeTime);

  let showMessageActions = false;
  let showMessageEditing = false;

  let noteTextEditable = note.data.text;

  $: noteLineCount = note.data.text.split('\n').length;

  function fromSelf(note: Note_v1_Doc) {
    return $appState.auth_user.email === note.data.userId;
  }
</script>

<style>
  .from-self {
    padding-left: 10%;
  }

  .from-other {
    padding-right: 10%;
  }

  .from-self .metadata {
    text-align: right;
  }
</style>
